import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Center, HStack, Text, VStack } from '@chakra-ui/react';

type ImageTileResultProps = {
  onClick?: () => {};
  bgImage: string;
  title?: string;
  type?: string;
  highlights?: string;
  backgroundType?: string;
  height?: number;
  showArrow?: boolean;
};

const ImageTileResult = ({ onClick, bgImage, title, type, highlights, backgroundType, height = 500, showArrow = true }: ImageTileResultProps) => {
  return (
      <Box
        height={height}
        width='100%'
        backgroundImage={bgImage}
        backgroundRepeat='no-repeat'
        backgroundPosition='center'
        backgroundSize='cover'
        borderRadius='50'
        display='flex'
        justifyContent='center'
        alignItems='center'
        position='relative'
      >
         {showArrow &&  <Center
          position='absolute'
          top='8'
          left='8'
          w='40px'
          h='40px'
          bg='primary.white'
          color='primary.grey'
          borderRadius='100px'
          cursor='pointer'
          onClick={onClick}
        >
        <ChevronLeftIcon fontSize={28} />
        </Center>}
        <VStack
          background={backgroundType || 'linear-gradient(180deg, rgba(75, 53, 40, 0.1) 0%, rgba(75, 53, 40, 0) 100%), linear-gradient(140.34deg, rgba(248, 223, 196, 0.46) -49.7%, rgba(255, 255, 255, 0) 100.32%)'}
          backdropFilter={backgroundType || 'blur(50px)'}
        borderRadius={[10, 40, 50]}
        padding={[5, 10, 30, 50]}
        >
        <Text color='primary.white' fontWeight={700} fontSize={[24, 32]}>
          {title}
          </Text>
          <HStack alignItems='baseline' gap={4}>
          <Text color='primary.white' fontWeight={700} fontSize={[14, 16, 18]}>
              {type}
            </Text>
            <Text color='primary.white' fontWeight={400} fontSize='12px'>
              {highlights}
            </Text>
          </HStack>
        </VStack>
      </Box>
  );
};

export { ImageTileResult };
